export const getPsiToPathName = (t = {}, base = {}) => {
    base = {
        psiUrlContract: '/psi-purOrder',
        psiUrlSupContract: '/psi-supOrder',
        psiSettleUrl: '/psi-finance',
        psiBasicUrl: '/psi-basic',
        ...base,
    };
    const businessCode = t.businessCode || t.busCode || '';
    const variables = {
        ...(t.variables || {}),
    };
    // let userInfo: Partial<{
    //   id: string;
    //   loginName: string;
    //   name: string;
    //   code: string;
    //   mobile: string;
    //   antUserDid: string;
    //   defaultCompId: string;
    //   companyName: string;
    //   antCompanyDid: string;
    //   employeeId: string;
    //   employeeName: string;
    //   oauthSource?: any;
    //   userOauthId?: any;
    // }> = JSON.parse(sessionStorage.getItem('USER_INFO') || '{}');
    // 调价单
    if (businessCode === 'psi-settle1080') {
        const urlPre = variables?.settleType === 1 ? 'pur_bill' : 'sup_bill';
        return base.psiSettleUrl + `/${urlPre}/adjust/detail?id=` + t.businessKey;
    }
    if (businessCode === 'psi1010') {
        // 合同
        if (variables.type == 1) {
            // 采购合同
            return (base.psiUrlContract + '/purOrder/contract/detail?id=' + t.businessKey);
        }
        else {
            // 销售合同
            return (base.psiUrlSupContract + '/supOrder/contract/detail?id=' + t.businessKey);
        }
    }
    if (businessCode === 'psi1020') {
        // 采购订单
        if (variables.type == 1) {
            // 采购订单
            return (base.psiUrlContract + '/purOrder/orderTable/detail?id=' + t.businessKey);
        }
        else {
            // 销售订单
            return (base.psiUrlSupContract +
                '/supOrder/orderTable/detail?id=' +
                t.businessKey);
        }
    }
    if (businessCode === 'psi1030') {
        // 发货（到货）
        return (base.psiUrlSupContract + '/supOrder/shipments/detail?id=' + t.businessKey);
    }
    if (businessCode === 'psi1040') {
        // 采购退货
        return base.psiUrlContract + '/purOrder/return/detail?id=' + t.businessKey;
    }
    if (businessCode === 'psi1050') {
        // 销售退货
        return (base.psiUrlSupContract + '/supOrder/saleReturn/detail?id=' + t.businessKey);
    }
    if (businessCode === 'psi1060') {
        // 收货
        return base.psiUrlContract + '/purOrder/receive/detail?id=' + t.businessKey;
    }
    if (businessCode === 'psi2020') {
        // 物权转移
        if (variables.type == 1) {
            // 采购物权转移
            return (base.psiUrlContract + '/purOrder/pur-transfer-property/detail?id=' + t.businessKey);
        }
        else {
            // 销售物权转移
            return (base.psiUrlSupContract + '/supOrder/sup-transfer-property/detail?id=' + t.businessKey);
        }
    }
    // 调价单
    if (businessCode === 'psi-settle1080') {
        const urlPre = variables?.settleType === 1 ? 'pur_bill' : 'sup_bill';
        return base.psiSettleUrl + `/${urlPre}/adjust/detail?id=` + t.businessKey;
    }
    // 收付款
    if (businessCode === 'psi-settle1010') {
        const url = variables?.type === 2
            ? '/sup_bill/pur-capital-flow/pay/-detail'
            : '/pur_bill/sup-capital-flow/income/-detail';
        return base.psiSettleUrl + `${url}?id=` + t.businessKey;
    }
    // 发票
    if (businessCode === 'psi-settle1060') {
        const url = variables?.type === 2
            ? '/pur_bill/sup-invoice/output/-detail'
            : '/sup_bill/pur-invoice/income/-detail';
        return base.psiSettleUrl + `${url}?id=` + t.businessKey;
    }
    // 应付 收款结算单
    if (businessCode === 'psi-settle1030') {
        const urlName = variables?.settleType == 2 ? 'handle' : 'receivable';
        const urlPre = variables?.settleType === 1 ? 'pur_bill' : 'sup_bill';
        return (base.psiSettleUrl +
            `/${urlPre}/settlement/${urlName}/detail?id=${t.businessKey}&type=${variables?.type || 1}`);
    }
    // 核销单
    if (businessCode === 'psi-settle1050') {
        const urlName2 = variables?.type == 2 ? 'handle' : 'receivable';
        const urlPre2 = variables?.type == 1 ? 'pur_bill' : 'sup_bill';
        return (base.psiSettleUrl +
            `/${urlPre2}/writeoff/${urlName2}/detail?id=${t.businessKey}&type=${variables?.type || 1}`);
    }
    // 展期申请
    if (businessCode === 'psi-settle1090') {
        return (base.psiSettleUrl +
            `/pur_bill/extend-apply/detail?id=${t.businessKey}`);
    }
    // 抵质押
    if (businessCode === 'scm4010') {
        return (base.psiBasicUrl + `/basicMage/pledge/-detail?id=${t.businessKey}`);
    }
    // 举报监督
    if (businessCode === 'scm4020') {
        return (base.psiBasicUrl + `/basicMage/supervision/-detail?id=${t.businessKey}`);
    }
};
export const getPsiIconNameByBusCode = (businessCode, type) => {
    if (businessCode === 'psi1010') {
        if (type === 1) {
            return '采购管理'; // pur
        }
        else {
            return '销售管理'; // sup
        }
    }
    if (businessCode === 'psi1020') {
        return '采购管理'; // pur
    }
    if (businessCode === 'psi1030') {
        return '销售管理'; // sup
    }
    if (businessCode === 'psi1040') {
        return '采购管理'; // pur
    }
    if (businessCode === 'psi1050') {
        return '销售管理'; // sup
    }
    if (businessCode === 'psi1060') {
        return '采购管理'; // pur
    }
    if (businessCode === 'psi2020') {
        if (type === 1) {
            return '采购管理'; // 'pur';
        }
        else {
            return '销售管理'; // sup
        }
    }
    if (businessCode === 'psi-settle1010') {
        return '财务管理'; // 'settle1010';
    }
    if (businessCode === 'psi-settle1060') {
        return '财务管理'; // 'settle1060';
    }
    if (businessCode === 'psi-settle1030') {
        return '财务管理'; // 'settle1030';
    }
    if (businessCode === 'psi-settle1050') {
        return '财务管理'; // 'settle1050';
    }
    if (businessCode === 'psi-settle1080') {
        return '财务管理'; // 'settle1050';
    }
    if (businessCode === 'psi-settle1090') {
        return '财务管理'; // 'settle1090';
    }
    if (['scm4010', 'scm4020'].includes(businessCode)) {
        return '基础管理';
    }
    return businessCode;
};
export const psiToPathNameMap = (function () {
    return {
        psi1010: getPsiToPathName,
        psi1020: getPsiToPathName,
        psi1030: getPsiToPathName,
        psi1040: getPsiToPathName,
        psi1050: getPsiToPathName,
        psi1060: getPsiToPathName,
        psi2020: getPsiToPathName,
        scm4010: getPsiToPathName,
        scm4020: getPsiToPathName,
        'psi-settle1010': getPsiToPathName,
        'psi-settle1060': getPsiToPathName,
        'psi-settle1080': getPsiToPathName,
        'psi-settle1030': getPsiToPathName,
        'psi-settle1050': getPsiToPathName,
        'psi-settle1090': getPsiToPathName,
    };
})();
